// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"ba7c4daf","52":"c5f47f42","313":"96ea1094","322":"697e73cb","422":"8017f441","558":"c42e7fe5","574":"fd0bc3ff","654":"fae5e2dd","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};